import { REWARD_TYPE } from '@constants/tournamentConstants'

// FREEBET vs AMOUNT reward display — the one place this branches. DefenderV2
// repeated this inline in 3 files (card footer, leaderboard bar, prize rows).
const RewardValue = ({ rewardType, amount, freeBets }) => {
  if (rewardType === REWARD_TYPE.FREEBET) {
    return (
      <span className="standard-normal-tournaments-reward-value standard-normal-tournaments-reward-value-freebet">
        {freeBets ?? amount} Freebets
      </span>
    )
  }

  return <span className="standard-normal-tournaments-reward-value">{amount}</span>
}

export default RewardValue
